import { ReturnProductDetailsComponent } from './return-prodcut-details.component';

export default ReturnProductDetailsComponent;
